import { Button, Form, Input, message } from "antd";
import {
  BibAllowFormField,
  BibAllowFormValues,
} from "features/events/components/event-result/bib-allocation-table/types";
import { useBoothTarget } from "features/events/use-cases/booth-target";
import { FormSectionsSeparator } from "features/users/components/modals/form-sections-separator";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const AddTargetModal = ({
  onClose,
  showAddEventModal,
  organizerData,
  refetch
}: {
  onClose: () => void;
  showAddEventModal: boolean;
  organizerData: any;
  refetch:any
}) => {
  const { t } = useTranslation();
  const formName = "add-target-form";
  const [validateTrigger, setValidateTrigger] = useState(["onSubmit"]);
  const [form] = Form.useForm<BibAllowFormValues>();
  
  const { isLoading, mutate } = useBoothTarget();

  const getInitialValues = {
    [BibAllowFormField.EventId]: undefined,
    TargetValue: undefined, // ✅ new field
  };

  const handleUpdate = (formData: BibAllowFormValues & { TargetValue: number }) => {
    const payload={
        EventId:organizerData?.EventId,
        TargetValue : +formData.TargetValue // ✅ ensure number
    }

    mutate(payload, {
      onSuccess: (data: any) => {
        const { ResponseStatus, ResponseMessage } = data;

        if (ResponseStatus === 1) {
          message.success(ResponseMessage);
          refetch()
          handleSuccess();
        } else {
          message.error(ResponseMessage);
        }
      },
    });
  };

  const handleSuccess = () => {
    onClose();
  };

  useEffect(() => {
    if (organizerData) {
      form.setFieldsValue(organizerData);
    } else {
      form.resetFields();
    }
  }, [organizerData, showAddEventModal]);

  return (
    <>
      <div className={"popup"}>
        <div className="modal_head">
          <button onClick={onClose} className="close-btn">
            &times;
          </button>
          <h4>{organizerData ? "Update Target Value" : "Add Target Value"}</h4>
        </div>
        <div className="modal_body">
          <Form
            id={formName}
            name={formName}
            form={form as any}
            layout="vertical"
            initialValues={getInitialValues}
            onFinish={handleUpdate}
            onFinishFailed={() => {
              setValidateTrigger(["onChange"]);
            }}
            validateTrigger={validateTrigger}
            disabled={isLoading}
          >
            <FormSectionsSeparator title={""}>
              <Form.Item
                label={"Target Value"}
                name={"TargetValue"} // ✅ only one field
                rules={[
                  {
                    required: true,
                    message: t("validateMessages.custom.nomsg"),
                  },
                ]}
              >
                <Input type="number" placeholder={"Target Value"} />
              </Form.Item>
            </FormSectionsSeparator>
          </Form>

          <div className="button-group">
            <Button
              loading={isLoading}
              htmlType="submit"
              onClick={form.submit}
              className="btn"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
